import { render, staticRenderFns } from "./MedicalCaseDetails.vue?vue&type=template&id=65a9f0da&scoped=true"
import script from "./MedicalCaseDetails.vue?vue&type=script&lang=js"
export * from "./MedicalCaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9f0da",
  null
  
)

export default component.exports